var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"app",staticClass:"app-component",attrs:{"id":"app"}},[_c('side-menu'),_c('router-view',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]}),_c('foot-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }